const THREE = require('three')

let base = require('src/../config').build.assetsPublicPath

import * as spritePositions from './spawnSprites'

export const tileSize = 120

export const direction = {
  N: 0,
  E: 90,
  S: 180,
  W: 270
}




// ***********************************************************************
//
// SOUNDS
//
// ***********************************************************************
export const sounds = {
  // crowd_start: {
  //   url: require('src/assets/sounds/fx/crowd/crowd_start.mp3'),
  //   size: 88727,
  //   distance: 90,
  //   rollOff: 8,
  //   volume: 0.9
  // },
  // crowd_finish: {
  //   url: require('src/assets/sounds/fx/crowd/finish.mp3'),
  //   size: 130713,
  //   distance: 120,
  //   volume: 0.5
  // },
  crowd_encourage1: {
    url: require('src/assets/sounds/fx/crowd/crowd_encourage1.mp3'),
    size: 83351,
    distance: 70,
    rollOff: 10,
    volume: 0.5
  },
  crowd_encourage2: {
    url: require('src/assets/sounds/fx/crowd/crowd_encourage2.mp3'),
    size: 77207,
    distance: 100,
    rollOff: 10,
    volume: 1.3
  }
  // emoji: {
  //   url: require('src/assets/sounds/fx/emoji.mp3'),
  //   size: 130713,
  //   distance: 60,
  //   volume: 0.5
  // }
}







// ***********************************************************************
//
// TEXTURES
//
// ***********************************************************************
export const textures = {
  start_line: {
    url: require('assets/models/track/textures/start_line.png'),
    size: 272,
    materialType: THREE.MeshStandardMaterial,
    options: {
      metalness: 0.0,
      roughness: 0.6
    }
  },
  start_road: {
    url: require('assets/models/track/textures/start_road.png'),
    size: 96473,
    materialType: THREE.MeshPhongMaterial,
    options: {
      shininess: 18
      // bumpMap: 'self',
      // bumpScale: 0.15
    }
  },
  start_wall: {
    url: require('assets/models/track/textures/start_wall.png'),
    size: 3569,
    materialType: THREE.MeshPhongMaterial
  },
  start_wall_mapped: {
    url: require('assets/models/track/textures/start_wall.png'),
    size: 3569,
    materialType: THREE.MeshPhongMaterial,
    options: {
      alphaMap: 'self'
    }
  },
  road: {
    url: require('assets/models/track/textures/road.png'),
    size: 105422,
    materialType: THREE.MeshPhongMaterial,
    options: {
      shininess: 18
      // bumpMap: 'self',
      // bumpScale: 0.15
    }
  },
  kerbs: {
    url: require('assets/models/track/textures/kerbs.png'),
    size: 77252,
    // materialType: THREE.MeshPhongMaterial
    materialType: THREE.MeshStandardMaterial,
    options: {
      metalness: 0.2,
      roughness: 0.3
    }
  },
  tickers: {
    url: require('assets/models/track/textures/tickers.png'),
    size: 14173,
    materialType: THREE.MeshBasicMaterial,
    animate: -0.0006
  },
  ribbon_end: {
    url: require('assets/models/track/textures/tickers.png'),
    size: 14173,
    materialType: THREE.MeshBasicMaterial
  },
  text: {
    url: require('assets/models/track/textures/text.png'),
    size: 22807,
    materialType: THREE.MeshBasicMaterial,
    animate: -0.001
  },
  stadium: {
    url: require('assets/models/track/textures/stadium.png'),
    size: 2235,
    materialType: THREE.MeshStandardMaterial,
    options: {
      metalness: 0.3,
      roughness: 0.8
    }
  },
  crowd: {
    url: require('assets/models/track/textures/crowd.png'),
    size: 27537,
    materialType: THREE.MeshBasicMaterial
  },

  // SPEED WORLD
  speedworld_road: {
    url: require('assets/models/track/textures/speedworld_road.png'),
    size: 11639,
    materialType: THREE.MeshPhongMaterial
  },

  ribbon: {
    url: require('assets/models/track/textures/ribbon.png'),
    size: 7365,
    materialType: THREE.MeshBasicMaterial
  },

  // SPRITES
  tree: {
    url: require('assets/models/track/textures/tree.png'),
    size: 74753,
    materialType: THREE.MeshBasicMaterial,
    scale: {
      min: 23,
      max: 25
    }
  },
  airport: {
    url: require('assets/models/track/textures/airport.png'),
    size: 361,
    materialType: THREE.SpriteMaterial,
    options: {
      blending: THREE.AdditiveBlending
    },
    scale: {
      min: 1,
      max: 1
    },
    useSprite: true
  },
  people: {
    urls: [
      require('assets/models/track/textures/people/people_00.png'),
      require('assets/models/track/textures/people/people_01.png'),
      require('assets/models/track/textures/people/people_02.png'),
      require('assets/models/track/textures/people/people_03.png'),
      require('assets/models/track/textures/people/people_04.png'),
      require('assets/models/track/textures/people/people_05.png'),
      require('assets/models/track/textures/people/people_06.png'),
      require('assets/models/track/textures/people/people_07.png'),
      require('assets/models/track/textures/people/people_08.png'),
      require('assets/models/track/textures/people/people_09.png'),
      require('assets/models/track/textures/people/people_10.png'),
      require('assets/models/track/textures/people/people_11.png'),
      require('assets/models/track/textures/people/people_12.png'),
      require('assets/models/track/textures/people/people_13.png'),
      require('assets/models/track/textures/people/people_14.png'),
      require('assets/models/track/textures/people/people_15.png')
    ],
    size: 2000,
    materialType: THREE.MeshBasicMaterial,
    usePoints: true,
    scale: {
      min: 3.3,
      max: 3.4
    }
  },
  // emoji: {
  //   url: require('assets/models/track/textures/emoji.png'),
  //   size: 100,
  //   materialType: THREE.MeshBasicMaterial,
  //   blending: THREE.AdditiveBlending,
  //   scale: {
  //     min: 3.5,
  //     max: 3.6
  //   },
  //   offset: {
  //     y: 3
  //   }
  // },



  // EMOJIS
  emojis: {
    urls: [
      require('assets/models/track/textures/emojis/addoil.png'),
      require('assets/models/track/textures/emojis/clapping.png'),
      require('assets/models/track/textures/emojis/fire.png'),
      require('assets/models/track/textures/emojis/heartshape.png'),
      require('assets/models/track/textures/emojis/lightning.png'),
      require('assets/models/track/textures/emojis/muscle.png'),
      require('assets/models/track/textures/emojis/thumbsup.png')
    ],
    size: 4000,
    materialType: THREE.SpriteMaterial,
    scale: {
      min: 3.5,
      max: 3.6
    }
  }
}







// ***********************************************************************
//
// OBJECTS
//
// ***********************************************************************
export const objects = {

  // STRAIGHT
  road_straight: {
    url: require('assets/models/track/models/sn_road_00.json'),
    size: 793,
    texture: 'road'
  },
  kerbs_straight: {
    url: require('assets/models/track/models/sn_kerbs_00.json'),
    size: 1666,
    texture: 'kerbs'
  },
  barrier_straight: {
    url: require('assets/models/track/models/barrier_straight.json'),
    size: 48100,
    texture: 'start_wall_mapped'
  },

  // CURVE RIGHT
  road_curve_right: {
    url: require('assets/models/track/models/road_curve_right.json'),
    size: 4329,
    texture: 'road'
  },
  kerbs_curve_right: {
    url: require('assets/models/track/models/kerbs_curve_right.json'),
    size: 8344,
    texture: 'kerbs'
  },
  arrow_curve_right: {
    url: require('assets/models/track/models/arrow_curve_right.json'),
    size: 4967,
    texture: 'tickers'
  },

  // CURVE LEFT
  road_curve_left: {
    url: require('assets/models/track/models/road_curve_left.json'),
    size: 4357,
    texture: 'road'
  },
  kerbs_curve_left: {
    url: require('assets/models/track/models/kerbs_curve_left.json'),
    size: 16754,
    texture: 'kerbs'
  },
  arrow_curve_left: {
    url: require('assets/models/track/models/arrow_curve_left.json'),
    size: 5021,
    texture: 'tickers'
  },

  // START
  start_line: {
    url: require('assets/models/track/models/start_line.json'),
    size: 938,
    texture: 'start_line'
  },
  road_straight_start: {
    url: require('assets/models/track/models/road_straight_start_0.json'),
    size: 787,
    texture: 'start_road'
  },
  kerbs_straight_start: {
    url: require('assets/models/track/models/kerbs_straight_start_0.json'),
    size: 1631,
    texture: 'kerbs'
  },
  wall_straight_start: {
    url: require('assets/models/track/models/wall_straight_start_0.json'),
    size: 12164,
    texture: 'start_wall',
    renderOrder: 100
  },
  arch_start_lighting: {
    url: require('assets/models/track/models/arch_start_lighting.json'),
    size: 6419,
    texture: 'tickers'
  },
  arch_start_ticker: {
    url: require('assets/models/track/models/arch_start_ticker.json'),
    size: 815,
    texture: 'tickers'
  },
  cage_start: {
    url: require('assets/models/track/models/cage_start.json'),
    size: 64076,
    texture: 'start_wall',
    renderOrder: 100
  },
  stadium_building: {
    url: require('assets/models/track/models/stadium_building.json'),
    size: 50892,
    texture: 'stadium'
  },
  stadium_crowd: {
    url: require('assets/models/track/models/stadium_crowd.json'),
    size: 11353,
    texture: 'crowd'
  },
  garage_start: {
    url: require('assets/models/track/models/garage_start.json'),
    size: 15566,
    texture: null
  },
  ribbon_left: {
    url: require('assets/models/track/models/ribbon_left.json'),
    size: 2826,
    texture: 'ribbon'
  },
  ribbon_right: {
    url: require('assets/models/track/models/ribbon_right.json'),
    size: 2793,
    texture: 'ribbon'
  },

  // SPECIAL
  strobe_road: {
    url: require('assets/models/track/models/strobe_road.json'),
    size: 775,
    texture: 'tickers',
    cloneMaterial: true
  },
  strobe_left: {
    url: require('assets/models/track/models/strobe_left.json'),
    size: 55367,
    texture: 'tickers'
  },
  strobe_right: {
    url: require('assets/models/track/models/strobe_right.json'),
    size: 54980,
    texture: 'tickers'
  },
  ticker_left: {
    url: require('assets/models/track/models/ticker_left.json'),
    size: 1692,
    texture: 'text'
  },
  ticker_right: {
    url: require('assets/models/track/models/ticker_right.json'),
    size: 1638,
    texture: 'text'
  },

  // SPEED WORLD
  speedworld_road: {
    url: require('assets/models/track/models/speedworld_road.json'),
    size: 751,
    texture: 'speedworld_road'
  }

}





// ***********************************************************************
//
// TILE TYPES
//
// ***********************************************************************
export const types = {

  // FINISH LINE
  finish: {
    objs: [
      'start_line',
      'road_straight_start',
      'kerbs_straight_start',
      'wall_straight_start',
      'ticker_left',
      'ticker_right',
      'ribbon_left',
      'ribbon_right'
    ],
    sprites: {
      people: spritePositions.peopleSpawnStart
    },
    directionChange: 0
  },

  // START
  start: {
    objs: [
      'road_straight',
      'kerbs_straight_start',
      'arch_start_lighting',
      'arch_start_ticker',
      'cage_start',
      'stadium_building',
      'stadium_crowd',
      'garage_start',
      'ticker_left',
      'ticker_right'
    ],
    sprites: {
      people: spritePositions.peopleSpawnStart
    },
    sounds: {
      // crowd_start: [
      //   {
      //     x: -10,
      //     y: 2.25,
      //     z: -30
      //   },
      //   {
      //     x: 10,
      //     y: 2.25,
      //     z: 30
      //   }
      // ]
    },
    directionChange: 0
  },

  // STRAIGHTS
  straight: {
    objs: [
      'barrier_straight',
      'road_straight',
      'kerbs_straight'
    ],
    sprites: {
      tree: spritePositions.treeSpawnStraight
    },
    directionChange: 0
  },
  straightStrobe: {
    objs: [
      'barrier_straight',
      'road_straight',
      'strobe_road',
      'kerbs_straight'
    ],
    sprites: {
      tree: spritePositions.treeSpawnStraight
    },
    directionChange: 0
  },
  straightStrobeLeft: {
    objs: [
      'barrier_straight',
      'road_straight',
      'strobe_road',
      'kerbs_straight',
      'strobe_left',
      'ticker_left'
    ],
    sprites: {
      tree: spritePositions.treeSpawnStraight
    },
    directionChange: 0
  },
  straightStrobeRight: {
    objs: [
      'barrier_straight',
      'road_straight',
      'strobe_road',
      'kerbs_straight',
      'strobe_right',
      'ticker_right'
    ],
    sprites: {
      tree: spritePositions.treeSpawnStraight
    },
    directionChange: 0
  },
  straightStrobeStadium: {
    objs: [
      'barrier_straight',
      'road_straight',
      'strobe_road',
      'kerbs_straight',
      'stadium_building',
      'stadium_crowd'
    ],
    sprites: {
      tree: spritePositions.treeSpawnStraight
    },
    directionChange: 0
  },
  straightAirport: {
    objs: [
      'barrier_straight',
      'road_straight',
      'kerbs_straight'
    ],
    sprites: {
      tree: spritePositions.treeSpawnStraight,
      airport: spritePositions.airportLightsSpawnStraight
    },
    directionChange: 0
  },

  // TURNS
  left: {
    objs: [
      'road_curve_left',
      'kerbs_curve_left',
      'arrow_curve_left'
    ],
    sprites: {
      tree: spritePositions.treeSpawnLeft,
      // emoji: spritePositions.peopleSpawnCurveLeft,
      people: spritePositions.peopleSpawnCurveLeft
    },
    sounds: {
      crowd_encourage1: [
        {
          x: 15,
          y: 2.25,
          z: 15
        }
      ]
    },
    directionChange: -90
  },
  right: {
    objs: [
      'road_curve_right',
      'kerbs_curve_right',
      'arrow_curve_right'
    ],
    sprites: {
      tree: spritePositions.treeSpawnRight,
      // emoji: spritePositions.peopleSpawnCurveRight,
      people: spritePositions.peopleSpawnCurveRight
    },
    sounds: {
      crowd_encourage1: [
        {
          x: -15,
          y: 2.25,
          z: 15
        }
      ]
    },
    directionChange: 90
  },
  leftAirport: {
    objs: [
      'road_curve_left',
      'kerbs_curve_left',
      'arrow_curve_left'
    ],
    sprites: {
      tree: spritePositions.treeSpawnLeft,
      people: spritePositions.peopleSpawnCurveLeft,
      // emoji: spritePositions.peopleSpawnCurveLeft,
      airport: spritePositions.airportLightsSpawnCurveLeft
    },
    sounds: {
      crowd_encourage2: [
        {
          x: 15,
          y: 2.25,
          z: 15
        }
      ]
    },
    directionChange: -90
  },
  rightAirport: {
    objs: [
      'road_curve_right',
      'kerbs_curve_right',
      'arrow_curve_right'
    ],
    sprites: {
      tree: spritePositions.treeSpawnRight,
      people: spritePositions.peopleSpawnCurveRight,
      // emoji: spritePositions.peopleSpawnCurveRight,
      airport: spritePositions.airportLightsSpawnCurveRight
    },
    sounds: {
      crowd_encourage2: [
        {
          x: -15,
          y: 2.25,
          z: 15
        }
      ]
    },
    directionChange: 90
  },

  // SPEED WORLD
  speed_straight: {
    objs: [
      'speedworld_road',
      'kerbs_straight'
    ],
    sprites: {
      tree: spritePositions.treeSpawnStraight
    },
    directionChange: 0
  }

}





// ***********************************************************************
//
// LAYOUT
//
// ***********************************************************************
export const layout = [

  // START
  'start',
  'start',
  // 'straight', // DEBUG
  'straight',
  'straight',
  'straight',

  // EAST TURN
  'right',
  'straight',
  'straight',
  'right',
  'straight',
  'left',
  'straight',
  'right',

  // SOUTH STRAIGHT
  'straight',
  'straight',
  'straightStrobeRight',
  'straightStrobeRight',
  'straightStrobeRight',
  'straightStrobeRight',
  'straightStrobeLeft',
  'straightStrobeLeft',
  'straightStrobeLeft',
  'straightStrobeLeft',
  'straightStrobeStadium',
  'straightAirport',
  'straightAirport',

  // WEST TURN
  'rightAirport',
  'straightAirport',
  'straightAirport',
  'straightAirport',
  'straightAirport',
  'rightAirport',

  // HOME STRETCH
  'straight',
  'straight',
  'straight',
  'straight',
  'straight',
  'straight',
  'straight',
  'straight',
  'straight',

  // FINISH
  'finish'

]

export const numDraw = layout.length / 2 - 1
// export const numDraw = 5




// WEBPACK FOOTER //
// ./src/components/game/track-tiled/config.js